"use strict";

function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
        return typeof o
    } : function (o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o
    }, _typeof(o)
}

function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable
        })), t.push.apply(t, o)
    }
    return t
}

function _objectSpread(e) {
    for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
            _defineProperty(e, r, t[r])
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r))
        })
    }
    return e
}

function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {value: value, enumerable: true, configurable: true, writable: true})
    } else {
        obj[key] = value
    }
    return obj
}

function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key)
}

function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.")
    }
    return (hint === "string" ? String : Number)(input)
}

var initialTextElement = function initialTextElement(elementName, text, wrapClassName) {
    var wrapper = document.createElement("div");
    wrapper.classList.add(wrapClassName);
    wrapper.style.overflow = "hidden";
    var element = document.createElement(elementName);
    element.innerText = text;
    wrapper.appendChild(element);
    return wrapper
};
var initialImageElement = function initialImageElement(src, alt, wrapClassName, imageClassName) {
    var wrapper = document.createElement("div");
    wrapper.classList.add(wrapClassName);
    var element = document.createElement("img");
    element.src = src;
    element.alt = alt;
    if (imageClassName) {
        element.classList.add(imageClassName)
    }
    wrapper.appendChild(element);
    return wrapper
};
var createTimelineAnimation = function createTimelineAnimation(targets, timeline, instanceParams, timelineOffset) {
    timeline.add(_objectSpread({targets: targets}, instanceParams), timelineOffset)
};
var setStyles = function setStyles(selector, CSSStyleDeclaration, cb) {
    var element = document.querySelector(selector);
    if (element) {
        for (var prop in CSSStyleDeclaration) {
            element.style[prop] = CSSStyleDeclaration[prop]
        }
        !!cb && cb()
    }
};
var getScrollInfo = function getScrollInfo() {
    var scrollY = window.scrollY;
    var windowHeight = window.innerHeight;
    var viewWidthFromTop = window.scrollY / 1440 * 100;// Вычисляем процент сколла
    var scrollPercentage = scrollY / (document.documentElement.scrollHeight - windowHeight) * 100;// Возвращаем объект с информацией о скролле
    return {scrollPercentage: scrollPercentage.toFixed(2), pixelsFromTop: scrollY, viewWidthFromTop: viewWidthFromTop}
};
var isMobile = function isMobile() {
    return window.innerWidth < 1024
};
var lerp = function lerp(a, b, n) {
    return (1 - n) * a + n * b
};
var runningTextAnimation = function runningTextAnimation(targets, configs) {
    var c = {translateX: "-100%", easing: "linear", loop: true, duration: 5000};
    if (configs) {
        c = _objectSpread(_objectSpread({}, c), configs)
    }
    return anime(_objectSpread({targets: targets}, c))
};
var initPreTitles = function initPreTitles() {
    var icons = gsap.utils.toArray(".material-item__plus, .a-details-item__info-img, .subscribe_plus, .head_plus, .why-plus");
    icons === null || icons === void 0 || icons.forEach(function (icon) {
        return icon.classList.add("animate-icon")
    })
};
var initTitles = function initTitles() {
    return
};
var initTitlesAnimation = function initTitlesAnimation() {
    var titles = gsap.utils.toArray(".material-item__plus, .a-details-item__info-img, .animate-icon");
    titles === null || titles === void 0 || titles.forEach(function (title) {
        var rect = title.getBoundingClientRect();
        var delay = title.dataset.delay ? parseFloat(title.dataset.delay) : 0;
        if (rect.top < window.innerHeight) {
            delay = +delay + 1
        }
        ScrollTrigger.create({
            trigger: title, start: "top bottom", once: true, onEnter: function onEnter() {
                return setTimeout(function () {
                    return title.classList.add("show")
                }, delay * 1000)
            }
        })
    })
};
var initAboutTitle = function initAboutTitle() {
    var title = document.querySelector(".about_banner-box-title");
    if (!title) return;
    var span = title.querySelectorAll("span");
    gsap.to(span, {duration: 1, opacity: 1, x: 0, xPercent: 0, ease: "power1.out"})
};
var shouldInitCollectionsSlider = function shouldInitCollectionsSlider() {
    return window.innerWidth > 1024
};
var resetCollectionsSlider = function resetCollectionsSlider(slider, id) {
    if (!slider) return;
    var proxyId = id || slider.__collectionsProxyId;
    var slides = slider.querySelectorAll(".swiper-slide");
    var pagId = slider.dataset.pagination;
    var pagination = slider.parentNode.querySelector(".swiper-pagination[data-slider=\"".concat(pagId, "\"]"));
    var thumb = slider.parentNode.querySelectorAll(".swiper-thumb");
    var proxy = proxyId ? document.querySelector("#".concat(proxyId)) : null;
    var drag = proxyId ? Draggable.get("#".concat(proxyId)) : null;
    drag === null || drag === void 0 || drag.kill();
    proxy === null || proxy === void 0 || proxy.remove();
    if (pagination) pagination.innerHTML = "";
    if (slider.__collectionsResizeObserver) {
        slider.__collectionsResizeObserver.disconnect();
        slider.__collectionsResizeObserver = null
    }
    ScrollTrigger.getAll().forEach(function (trigger) {
        if (trigger.trigger === slider) trigger.kill()
    });
    gsap.set(slider, {clearProps: "width,height"});
    gsap.set(slides, {clearProps: "all"});
    gsap.set(thumb, {clearProps: "all"});
    delete slider.__collectionsProxyId
};
var collectionsSlider = function collectionsSlider() {
    var sliders = document.querySelectorAll(".collections_section-swiper");
    var timeout = null;
    sliders === null || sliders === void 0 || sliders.forEach(function (slider, i) {
        var id = "slider".concat(i);
        if (shouldInitCollectionsSlider()) initCollectionsSlider(slider, id);else resetCollectionsSlider(slider, id)
    });
    window.addEventListener("resize", function () {
        clearTimeout(timeout);
        timeout = setTimeout(function () {
            sliders === null || sliders === void 0 || sliders.forEach(function (slider, i) {
                var id = "slider".concat(i);
                resetCollectionsSlider(slider, id);
                if (shouldInitCollectionsSlider()) initCollectionsSlider(slider, id)
            })
        }, 200)
    })
};
var initCollectionsSlider = function initCollectionsSlider(slider, id) {
    var realIndex;
    var rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
    var ww = window.innerWidth;
    if (!slider || !shouldInitCollectionsSlider()) {
        resetCollectionsSlider(slider, id);
        return
    }
    var isDesktop = function isDesktop() {
        return ww > 1024
    };
    var isTablet = function isTablet() {
        return ww <= 1024
    };
    var deskPadding = 0.08333 * ww;
    var deskSlideWidth = (ww - 3.5 * rem) * 0.25 + deskPadding;
    var mobileSlideWidth = 19.5 * rem;
    var picker = slider;
    var slides = slider.querySelectorAll(".swiper-slide");
    var pagId = slider.dataset.pagination;
    var pagination = slider.parentNode.querySelector(".swiper-pagination[data-slider=\"".concat(pagId, "\"]"));
    var thumb = slider.parentNode.querySelectorAll(".swiper-thumb");
    var proxy = document.createElement("div");
    var slideWidth = isDesktop() ? deskSlideWidth : mobileSlideWidth;
    var numSlides = slides.length;
    var slideStep = 1 / numSlides;
    var sliderWidth = slideWidth * numSlides;
    var sliderHeight = 0;
    var tl = gsap.timeline({paused: true, ease: "none"});
    var snapArray = [];
    proxy.id = id;
    slider.__collectionsProxyId = id;
    document.body.appendChild(proxy);
    gsap.set(picker, {width: sliderWidth - slideWidth});
    gsap.set(thumb, {"--progress": isDesktop() ? 1 / numSlides : 0});
    if (isDesktop()) {
        realIndex = 1
    } else {
        realIndex = 0
    }
    slides === null || slides === void 0 || slides.forEach(function (slide, i) {
        gsap.set(slide, {clearProps: "all"});
        initSlide(slide, i);
        sliderHeight = Math.max(sliderHeight, slide.scrollHeight);
        snapArray.push(Math.round(i * slideWidth))
    });
    gsap.set(picker, {height: sliderHeight + gsap.getProperty(picker, "paddingBottom")});
    var bullets = pagination === null || pagination === void 0 ? void 0 : pagination.querySelectorAll(".swiper-pagination-bullet");
    var animation = gsap.timeline({repeat: -1, paused: true, ease: "none"});
    animation.add(tl.tweenFromTo(1, 2, {immediateRender: true}));
    var snapX = function snapX(x) {
        return Math.round(x / slideWidth) * slideWidth
    };
    var wrapProgress = gsap.utils.wrap(0, 1);
    var updateBullets = function updateBullets() {
        bullets === null || bullets === void 0 || bullets.forEach(function (bullet) {
            var i = Number(bullet.dataset.index);
            var activeIndexes;
            if (window.innerWidth <= 767) {
                activeIndexes = [realIndex, (realIndex + 1) % numSlides]
            } else {
                activeIndexes = [(realIndex - 1 + numSlides) % numSlides, realIndex, (realIndex + 1) % numSlides, (realIndex + 2) % numSlides]
            }
            if (activeIndexes.includes(i)) {
                bullet.classList.add("swiper-pagination-bullet-active")
            } else {
                bullet.classList.remove("swiper-pagination-bullet-active")
            }
        })
    };

    function updateProgress() {
        var index = Math.round((1 - wrapProgress(snapX(this.x) / sliderWidth)) * numSlides);
        var index2 = 1 - wrapProgress(this.x / sliderWidth);
        var progress = wrapProgress(this.x / sliderWidth);
        animation.progress(progress);
        if (isDesktop()) {
            index = Math.round((1 - wrapProgress(snapX(this.x) / sliderWidth - slideStep)) * numSlides);
            index2 = 1 - wrapProgress(this.x / sliderWidth) + 1 / numSlides
        }
        realIndex = Math.round(index >= numSlides ? 0 : index);
        var thumbProgress = index2;
        gsap.set(thumb, {"--progress": thumbProgress, duration: 0.1, ease: "none"});
        updateBullets()
    }

    var draggable = new Draggable(proxy, {
        type: "x",
        trigger: picker,
        inertia: true,
        onDrag: updateProgress,
        onThrowUpdate: updateProgress,
        snap: {
            x: function x(_x) {
                return snapX(_x)
            }
        }
    });
    updateBullets();

    function initSlide(el, i) {
        var bullet = document.createElement("div");
        bullet.classList.add("swiper-pagination-bullet");
        bullet.dataset.index = i;
        pagination === null || pagination === void 0 || pagination.appendChild(bullet);
        bullet.addEventListener("click", function () {
            var x = -i * slideStep * sliderWidth;
            var progress = 1 - i * slideStep;
            if (isDesktop()) {
                x = !i ? slideWidth : (-i + 1) * slideStep * sliderWidth;
                progress = !i ? 1 + slideStep : 1 - (i - 1) * slideStep
            }
            var thumbX = 1 - progress + 1 / numSlides;
            gsap.to(draggable.target, {x: x, duration: 1});
            gsap.to(animation, {progress: progress, duration: 1});
            gsap.to(thumb, {duration: 0.2, "--progress": thumbX});
            realIndex = Math.round(i >= numSlides ? 0 : i);
            updateBullets()
        });
        gsap.set(el, {
            width: slideWidth,
            scale: isDesktop() ? 1 : 0.8,
            x: isDesktop() ? -1 * (slideWidth * (isTablet() ? 1.3 : 1.325)) : -slideWidth + rem
        });
        var tl2 = gsap.timeline({repeat: 1});
        var offset = isDesktop() ? slideStep : 0;
        tl2.to(el, {duration: 1, x: "+=" + sliderWidth, ease: "none"});
        if (isDesktop()) {
            tl2.to(el, {duration: slideStep, scale: 0.5, repeat: 1, yoyo: true, ease: "none"}, 0);
            tl2.to(el, {duration: slideStep, scale: 0.5, repeat: 1, yoyo: true, ease: "none"}, offset * 3)
        } else {
            tl2.to(el, {duration: slideStep, scale: 1, repeat: 1, yoyo: true, ease: "none"}, 0)
        }
        tl.add(tl2, i * -slideStep)
    }

    var resizeObserver = new ResizeObserver(function (entries) {
        slides === null || slides === void 0 || slides.forEach(function (slide) {
            sliderHeight = Math.max(sliderHeight, slide.scrollHeight)
        });
        gsap.set(picker, {height: sliderHeight + gsap.getProperty(picker, "paddingBottom")})
    });
    slider.__collectionsResizeObserver = resizeObserver;
    resizeObserver.observe(document.body);
    var helicopter = document.querySelector(".helicopter");
    if (!helicopter) return;
    ScrollTrigger.create({
        trigger: slider,
        start: "top 50%",
        end: "bottom 50%",
        scrub: true,
        onEnter: function onEnter() {
            return helicopter.classList.add("colorful")
        },
        onEnterBack: function onEnterBack() {
            return helicopter.classList.add("colorful")
        },
        onLeave: function onLeave() {
            return helicopter.classList.remove("colorful")
        },
        onLeaveBack: function onLeaveBack() {
            return helicopter.classList.remove("colorful")
        }
    })
};
var initRecommendedPostsSlider = function initRecommendedPostsSlider() {
    var sliders = document.querySelectorAll(".recommended-posts-slider");
    sliders === null || sliders === void 0 || sliders.forEach(function (el) {
        var slides = el.querySelectorAll(".swiper-slide");
        var slider = new Swiper(el, {
            slidesPerView: "auto",
            spaceBetween: 66,
            allowTouchMove: true,
            loop: false,
            breakpoints: {1080: {spaceBetween: 66}, 0: {spaceBetween: 40}}
        });
        if (slides.length < 5 && window, innerWidth > 1080) {
            slider.disable()
        }
    })
};
var isSafariBrowser = /Safari/i.test(navigator.userAgent) && !/Chrome|CriOS|Chromium|Android|FxiOS|EdgiOS/i.test(navigator.userAgent);
var initSmoothScroll = function initSmoothScroll() {
    if (isSafariBrowser || window.innerWidth < 1024) { /* PERF: disable Lenis smooth-scroll on mobile/tablet — native scroll is lighter on the main thread and removes older-phone scroll lag; mirrors the existing Safari-disabled path below */
        if (window.__lenisRafId) {
            cancelAnimationFrame(window.__lenisRafId);
            window.__lenisRafId = null
        }
        if (window.lenis && typeof window.lenis.destroy === "function") {
            window.lenis.destroy()
        }
        window.lenis = null;
        document.documentElement.classList.remove("lenis", "lenis-smooth", "lenis-scrolling", "lenis-stopped", "lenis-locked", "lenis-autoToggle");
        return null
    }
    var lenisSettings = {
        duration: 1.2,
        easing: function easing(t) {
            return t === 1 ? 1 : 1 - Math.pow(2, -10 * t)
        },// easing: (x) => Math.min(1, 1.001 - Math.pow(2, -10 * x)),
        orientation: "vertical",
        gestureOrientation: "vertical",
        smoothWheel: true,
        smoothTouch: false,
        wheelMultiplier: 1.2,
        touchMultiplier: 0.2,
        inifinite: false
    };
    if (window.__lenisRafId) {
        cancelAnimationFrame(window.__lenisRafId)
    }
    if (window.lenis && typeof window.lenis.destroy === "function") {
        window.lenis.destroy()
    }
    window.lenis = new Lenis(lenisSettings);
    var lenisInstance = window.lenis;
    var raf = function raf(time) {
        if (!window.lenis || window.lenis !== lenisInstance) {
            return
        }
        lenisInstance.raf(time);
        window.__lenisRafId = requestAnimationFrame(raf)
    };
    window.__lenisRafId = requestAnimationFrame(raf);
    return window.lenis
};
var initSound = function initSound() {
    var audio = document.querySelector("#steven-audio");
    var toggles = document.querySelectorAll(".steven-audio-toggle");
    var saveTimeout;
    if (!audio) return;
    audio.muted = false;
    audio.volume = 1;
    var saveTime = function saveTime() {
        return localStorage.setItem("audioTime", audio.currentTime)
    };
    var handlePlayError = function handlePlayError(error) {
        if (error.name === "NotAllowedError") {
            localStorage.setItem("musicState", "off");
            localStorage.setItem("audioState", "paused");
            toggles === null || toggles === void 0 || toggles.forEach(function (toggle) {
                return toggle.classList.remove("active")
            })
        }
    };
    var playAudio = function playAudio() {
        // Package 7 / 7.2.1 (Nick, 17 Aug): music is OPT-IN. The old check ("off" -> skip)
        // treated a FRESH visitor (no localStorage) as consented: the first click anywhere
        // started the soundtrack on every device. Now nothing plays until the visitor has
        // explicitly enabled it via the toggle ("on"); their choice still persists and
        // resumes across pages exactly as before.
        if (localStorage.getItem("musicState") !== "on") return;
        audio.play().then(function () {
            localStorage.setItem("audioState", "playing");
            toggles === null || toggles === void 0 || toggles.forEach(function (toggle) {
                return toggle.classList.add("active")
            })
        })["catch"](handlePlayError)
    };
    var handleUserInteraction = function handleUserInteraction() {
        if (localStorage.getItem("musicState") !== "on") return; // opt-in, see playAudio
        audio.play().then(function () {
            localStorage.setItem("audioState", "playing");
            toggles === null || toggles === void 0 || toggles.forEach(function (toggle) {
                return toggle.classList.add("active")
            })
        })["catch"](handlePlayError)
    };
    audio.addEventListener("timeupdate", function () {
        clearTimeout(saveTimeout);
        saveTimeout = setTimeout(saveTime, 1000)
    });
    audio.addEventListener("pause", function () {
        saveTime();
        localStorage.setItem("audioState", "paused")
    });
    audio.addEventListener("canplay", function () {
        var savedTime = localStorage.getItem("audioTime");
        var savedState = localStorage.getItem("audioState");
        if (savedTime) {
            audio.currentTime = parseFloat(savedTime)
        }
        if (savedState === "playing") {
            playAudio()
        }
    }, {once: true});
    document.addEventListener("click", handleUserInteraction);
    toggles === null || toggles === void 0 || toggles.forEach(function (toggle) {
        toggle.addEventListener("click", function (e) {
            e.preventDefault();
            var isMusicOn = localStorage.getItem("musicState") === "on"; // opt-in, see playAudio
            if (isMusicOn) {
                audio.pause();
                localStorage.setItem("musicState", "off");
                toggles === null || toggles === void 0 || toggles.forEach(function (el) {
                    return el.classList.remove("active")
                })
            } else {
                localStorage.setItem("musicState", "on");
                playAudio();
                toggles === null || toggles === void 0 || toggles.forEach(function (el) {
                    return el.classList.add("active")
                })
            }
        })
    })
};
window.global = _objectSpread(_objectSpread({}, window.global), {}, {
    initialTextElement: initialTextElement,
    initialImageElement: initialImageElement,
    createTimelineAnimation: createTimelineAnimation,
    setStyles: setStyles,
    getScrollInfo: getScrollInfo,
    isMobile: isMobile,
    runningTextAnimation: runningTextAnimation,
    initPreTitles: initPreTitles,
    initTitles: initTitles,
    initTitlesAnimation: initTitlesAnimation,
    initAboutTitle: initAboutTitle,
    collectionsSlider: collectionsSlider,
    initRecommendedPostsSlider: initRecommendedPostsSlider,
    isSafariBrowser: isSafariBrowser,
    initSmoothScroll: initSmoothScroll,
    initSound: initSound
});
//# sourceMappingURL=globalAnimations.js.map
